"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fieldNames = require("./fieldNames");
var _core = require("@stt-componentes/core");
var _formik = require("formik");
var _validationSchema = _interopRequireDefault(require("./validationSchema"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Busca = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../busca'));
  });
});
var Campos = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./campos'));
  });
});
var Imc = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../imc'));
  });
});
var Paciente = function Paciente(props) {
  var cpfPadrao = props['cpf-padrao'];
  var disabledBusca = props['disabled'];
  var strings = props.strings,
    campos = props.campos,
    headers = props.headers,
    formExterno = props.formExterno,
    usarTipoContato = props.usarTipoContato,
    persistirParametrosBusca = props.persistirParametrosBusca,
    imc = props.imc,
    setImcExterno = props.setImcExterno,
    _props$dataRealizacao = props.dataRealizacao,
    dataRealizacao = _props$dataRealizacao === void 0 ? null : _props$dataRealizacao,
    _props$esconderBusca = props.esconderBusca,
    esconderBusca = _props$esconderBusca === void 0 ? false : _props$esconderBusca,
    _props$abrirBuscaAuto = props.abrirBuscaAutomaticamente,
    abrirBuscaAutomaticamente = _props$abrirBuscaAuto === void 0 ? false : _props$abrirBuscaAuto,
    _props$suprimirModalC = props.suprimirModalCadastro,
    suprimirModalCadastro = _props$suprimirModalC === void 0 ? false : _props$suprimirModalC;
  var paciente = formExterno.paciente,
    setFieldValue = formExterno.setFieldValue,
    errors = formExterno.errors,
    submitCount = formExterno.submitCount,
    validateOnChange = formExterno.validateOnChange;
  var _useState = (0, _react.useState)(cpfPadrao ? true : false),
    _useState2 = _slicedToArray(_useState, 2),
    buscandoPacientePadrao = _useState2[0],
    setBuscandoPacientePadrao = _useState2[1];
  var _useState3 = (0, _react.useState)(cpfPadrao ? true : false),
    _useState4 = _slicedToArray(_useState3, 1),
    pacientePadrao = _useState4[0];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    dadosCadastro = _useState6[0],
    setDadosCadastro = _useState6[1];
  var schema = (0, _validationSchema["default"])(strings, campos);
  var selecionarPaciente = function selecionarPaciente(dados) {
    setFieldValue(_fieldNames.PACIENTE, dados);
    setBuscandoPacientePadrao(false);
    setDadosCadastro(dados);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, !esconderBusca && /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    container: true,
    spacing: 1,
    style: {
      marginBottom: '8px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_core.SttCircularProgress, {
      color: "primary"
    })
  }, /*#__PURE__*/_react["default"].createElement(Busca, {
    strings: strings,
    headers: headers,
    usarTipoContato: usarTipoContato,
    persistirParametrosBusca: persistirParametrosBusca,
    callback: selecionarPaciente,
    "cpf-padrao": cpfPadrao,
    disabledBusca: disabledBusca,
    campos: campos,
    abrirBuscaAutomaticamente: abrirBuscaAutomaticamente,
    suprimirModalCadastro: suprimirModalCadastro
  })))), buscandoPacientePadrao ? /*#__PURE__*/_react["default"].createElement(_core.SttCircularProgress, {
    color: "primary"
  }) : (paciente.id || paciente.cpf || paciente.cns) && /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: paciente,
    validationSchema: schema,
    enableReinitialize: true,
    validateOnChange: validateOnChange === undefined ? true : validateOnChange
  }, function () {
    return /*#__PURE__*/_react["default"].createElement(Campos, {
      strings: strings,
      campos: campos.camposCadastro,
      contextoCadastroBasico: false,
      pacientePadrao: pacientePadrao,
      usarTipoContato: usarTipoContato,
      headers: headers,
      dadosCadastroOriginal: dadosCadastro,
      setExternalFieldValue: setFieldValue,
      errors: errors,
      submitCount: submitCount
    });
  }), imc && paciente.peso && paciente.altura && /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_core.SttCircularProgress, {
      color: "primary"
    })
  }, /*#__PURE__*/_react["default"].createElement(Imc, {
    values: paciente,
    strings: strings,
    setImcExterno: setImcExterno,
    dataRealizacao: dataRealizacao
  })))));
};
Paciente.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  headers: _propTypes["default"].object.isRequired,
  usarTipoContato: _propTypes["default"].bool,
  persistirParametrosBusca: _propTypes["default"].bool,
  imc: _propTypes["default"].bool,
  'cpf-padrao': _propTypes["default"].string,
  campos: _propTypes["default"].object.isRequired,
  formExterno: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = Paciente;